"use strict";

function addNotViewedCount() {
  var bookmarksField = document.getElementById('user-bookmarks');
  var bookmarksCount = document.getElementById('bookmarks-count'); // if counter already exists

  if (bookmarksCount) {
    var currCount = Number(bookmarksCount.innerText);
    bookmarksCount.innerText = currCount + 1;
  } else {
    var counter = document.createElement('span');
    counter.className = 'st_sidebar__item--number i-contest-count';
    counter.id = 'bookmarks-count';
    counter.textContent = '1';

    if (bookmarksField) {
      bookmarksField.insertAdjacentElement('beforeend', counter);
    }
  }
}

function toggleBookmarks(event, isWorkProgram) {
  var isDocument = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!event) return;
  var type = event.target.dataset.type;

  if (type === 'add') {
    addToBookmarks(event, isWorkProgram, isDocument);
  } else {
    removeFromBookmarks(event, isWorkProgram, isDocument);
  }
} // Two separate actions because of old bookmarks logic


function addToBookmarks(event, isWorkProgram, isDocument) {
  event.preventDefault();
  var type = event.target.dataset.type;
  var target = event.target;
  var docId = event.target.dataset.docId;
  var sectionId = event.target.dataset.sectionId;

  if (isWorkProgram) {
    iu.ajax(event, '/workProgram/favoriteAdd', {
      id: docId
    });
  } else {
    iu.ajax(event, '/add-document-to-bookmark', {
      document_id: docId,
      section_id: sectionId
    });
  }

  toggleFavourites(type, target, isDocument);
  addNotViewedCount();
}

function removeFromBookmarks(event, isWorkProgram, isDocument) {
  event.preventDefault();
  var type = event.target.dataset.type;
  var target = event.target;
  var docId = event.target.dataset.docId;
  var sectionId = event.target.dataset.sectionId;
  iu.dlg.confirm(event, 'Удалить из избранного', 'Вы уверены что хотите удалить запись из избранного?', function () {
    if (isWorkProgram) {
      iu.ajax(event, '/workProgram/favoriteDelete', {
        id: docId
      });
    } else {
      iu.ajax(event, '/remove-document-from-bookmark', {
        document_id: docId,
        section_id: sectionId
      });
    }

    toggleFavourites(type, target, isDocument);
  });
}

function toggleFavourites(type, link, isDocument) {
  if (type === 'delete') {
    if (isDocument) {
      link.classList.remove('methodical-docs__favorites--active');
    } else {
      link.textContent = 'Добавить в избранное';
      link.classList.remove('sg-button--gray');
    }

    link.dataset.type = 'add';
  } else if (type === 'add') {
    if (isDocument) {
      link.classList.add('methodical-docs__favorites--active');
    } else {
      link.textContent = 'Удалить из избранного';
      link.classList.add('sg-button--gray');
    }

    link.dataset.type = 'delete';
  }
}